// Import necessary functions from Firebase SDK
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import Firebase Authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for database operations

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBmBHbbuYbneqM2B2o4IykLFpIxcQUM4vo",
  authDomain: "football-scouting-website.firebaseapp.com",
  projectId: "football-scouting-website",
  storageBucket: "football-scouting-website.firebasestorage.app",
  messagingSenderId: "171299970732",
  appId: "1:171299970732:web:ef7c9ec1a8bf74bbdac909",
  measurementId: "G-XRX7ZEQ7W3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase Authentication instance
const auth = getAuth(app);

// Get Firestore instance
const db = getFirestore(app);  // Firestore instance for database operations

// Export auth and db for use in other parts of the app
export { auth, db };
